import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/constants";

const AuthCtx = createContext(null);

const TOKEN_KEY = "ft_token";
const ROLE_KEY = "ft_role";

export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [token, setTokenState] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [role, setRole] = useState(() => localStorage.getItem(ROLE_KEY));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const setAuth = useCallback((t, r) => {
    if (t) {
      localStorage.setItem(TOKEN_KEY, t);
      localStorage.setItem(ROLE_KEY, r);
    } else {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(ROLE_KEY);
    }
    setTokenState(t);
    setRole(r);
  }, []);

  const logout = useCallback(() => {
    setAuth(null, null);
    setUser(null);
  }, [setAuth]);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      setUser(null);
      return;
    }
    setLoading(true);
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setUser(res.data))
      .catch(() => logout())
      .finally(() => setLoading(false));
  }, [token, logout]);

  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <AuthCtx.Provider value={{ token, role, user, loading, setAuth, logout, authHeaders }}>
      {children}
    </AuthCtx.Provider>
  );
};

